import PropTypes from 'prop-types';

const propTypes = {
    value: PropTypes.any,
};

const contextTypes = {
    radioButtonContainer: PropTypes.object,
};

export const RadioButtonPlain = ({
    name,
    value,
    label,
    className = undefined,
    style = undefined,
    onChange,
    ...otherProps
}) => {
    const id = name + '-' + value;
    const inputProps = {
        ...otherProps,
        type: 'radio',
        name,
        value,
        id,
        onChange: event => onChange(event.target.value),
    };
    return label ? (
        <div className={className} style={style}>
            <input {...inputProps} />
            <label htmlFor={id}>{label}</label>
        </div>
    ) : (
        <input {...inputProps} />
    );
};

export default function RadioButton(props, context) {
    const { name, selected, onChange } = context.radioButtonContainer;
    const { value, label, className, style } = props;
    const mergedProps = {
        ...props,
        name,
        value,
        checked: selected === value,
        onChange: () => onChange(value),
        label,
        className,
        style,
    };
    return <RadioButtonPlain {...mergedProps} />;
}

RadioButton.propTypes = propTypes;
RadioButton.contextTypes = contextTypes;
